import React from 'react';
import { FileText, ChevronDown, ChevronUp, Calendar } from 'lucide-react';
import moment from 'moment';
import { utilMethods } from '../../util/util.js';

const InvoiceThumbPanel = ({ date, isActive, onToggle, children }) => (
  <div className="mb-6 bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
    <button
      type="button"
      onClick={onToggle}
      className="w-full px-8 py-5 flex items-center justify-between hover:bg-gray-50 transition-colors"
    >
      <div className="flex items-center space-x-3">
        <Calendar className="h-6 w-6 text-blue-600" />
        <span className="text-lg font-semibold text-gray-900">
          {moment(date).format('YYYY/MM/DD')}
        </span>
      </div>
      {isActive ? (
        <ChevronUp className="h-6 w-6 text-gray-400" />
      ) : (
        <ChevronDown className="h-6 w-6 text-gray-400" />
      )}
    </button>
    
    <div className={isActive ? 'block' : 'hidden'}>
      <div className="p-8 border-t border-gray-200 bg-gray-50">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {children}
        </div>
      </div>
    </div>
  </div>
);

const InvoiceThumb = ({ invNo, hasAttachment, attachmentURL }) => (
  <div className="group relative bg-white rounded-xl shadow-md border border-gray-200 p-6 hover:shadow-lg transition-all duration-200 hover:border-blue-200">
    <div className="aspect-w-3 aspect-h-4 mb-4">
      <div className="flex items-center justify-center bg-blue-50 rounded-lg group-hover:bg-blue-100 transition-colors">
        <FileText className="h-12 w-12 text-blue-600 group-hover:text-blue-700" />
      </div>
    </div>
    
    {hasAttachment ? (
      <button
        onClick={() => window.open(attachmentURL)}
        className="w-full text-center text-base font-semibold text-blue-600 hover:text-blue-700 truncate group-hover:underline"
      >
        {invNo}
      </button>
    ) : (
      <div className="w-full text-center text-base font-medium text-gray-500 truncate">
        {invNo}
      </div>
    )}
  </div>
);

class InvoiceThumbView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeKey: '1'
    };
  }

  handleSelect = (key) => {
    this.setState(prevState => ({
      activeKey: prevState.activeKey === key ? null : key
    }));
  };

  bindInvoices = (invoiceList) => {
    const invList = Object.keys(invoiceList);
    const sortedList = utilMethods.sortInvoiceArray(invList);
    
    return sortedList.map((item, index) => {
      const attachments = invoiceList[item.invNo] || [];
      const hasAttachment = attachments.length > 0;
      const attachmentURL = hasAttachment ? attachments[0].attachmentURL : null;
      
      return (
        <InvoiceThumb
          key={index}
          invNo={item.invNo}
          hasAttachment={hasAttachment}
          attachmentURL={attachmentURL}
        />
      );
    });
  };

  bindDateGroups = () => {
    let noInvoiceDatesCount = 0;
    const dateGroups = this.props.invoiceList.map((item, key) => {
      if (Object.keys(item.attachments || {}).length > 0) {
        const eventKey = (key + 1).toString();
        return (
          <InvoiceThumbPanel
            key={eventKey}
            date={item.createdDate}
            isActive={this.state.activeKey === eventKey}
            onToggle={() => this.handleSelect(eventKey)}
          >
            {this.bindInvoices(item.attachments)}
          </InvoiceThumbPanel>
        );
      } else {
        noInvoiceDatesCount++;
        return null;
      }
    });

    if (this.props.invoiceList.length === noInvoiceDatesCount) {
      return (
        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-8 text-center text-lg text-gray-500">
          No Invoices data exists for this month
        </div>
      );
    }

    return dateGroups;
  };

  render() {
    return (
      <div className="container mx-auto px-6 py-8">
        <div className="space-y-6">
          {this.bindDateGroups()}
        </div>
      </div>
    );
  }
}

export default InvoiceThumbView;
